var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportantNoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1273 3.89844L24.2632 19.7222H5.99145L15.1273 3.89844Z",
    fill: "#FFC02D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2629 9.17102L15.127 24.9948L5.99115 9.17102L24.2629 9.17102Z",
    fill: "#FFC02D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6758 14.4476L9.85201 23.5835L9.85201 5.31176L25.6758 14.4476Z",
    fill: "#FFC02D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4032 23.5832L4.57943 14.4473L20.4032 5.31146L20.4032 23.5832Z",
    fill: "#FFC02D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4081 16.2574L14.2131 10.1344H16.0981L15.9031 16.2574H14.4081ZM15.1621 19.2994C14.8414 19.2994 14.5771 19.204 14.3691 19.0134C14.1698 18.814 14.0701 18.5714 14.0701 18.2854C14.0701 17.9994 14.1698 17.761 14.3691 17.5704C14.5771 17.371 14.8414 17.2714 15.1621 17.2714C15.4828 17.2714 15.7428 17.371 15.9421 17.5704C16.1414 17.761 16.2411 17.9994 16.2411 18.2854C16.2411 18.5714 16.1414 18.814 15.9421 19.0134C15.7428 19.204 15.4828 19.2994 15.1621 19.2994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantNoteIcon);
export default __webpack_public_path__ + "static/media/ImportantNoteIcon.d25773a80d114617b5f2ba6cd47e3196.svg";
export { ForwardRef as ReactComponent };